import { memo } from 'react'
import { ErrorMessage, Field, FieldProps as FormikFieldProps } from 'formik'
import {
  CommonStyledInput,
  StyledInputError,
  StyledInputLabelWrapper,
  StyledLabel,
} from 'components/Input/styles'
import { useIntl } from 'react-intl'
import has from 'lodash/has'

import { FieldProps } from '../types'
import { textFieldMessages } from './messages'

function TextField({ showLabel = false, inputId, ...props }: FieldProps) {
  const { formatMessage } = useIntl()
  const { name, placeholder } = props
  return (
    <Field name={name}>
      {({ field, form: { errors, touched } }: FormikFieldProps) => (
        <>
          {showLabel && field?.value && (
            <StyledInputLabelWrapper>
              <StyledLabel htmlFor={inputId || name}>{placeholder}</StyledLabel>
            </StyledInputLabelWrapper>
          )}
          <CommonStyledInput
            type="text"
            id={inputId || name}
            placeholder={
              placeholder || `${formatMessage(textFieldMessages.placeholder)}`
            }
            invalid={has(errors, name) && has(touched, name)}
            {...field}
            {...props}
          />
          <StyledInputError>
            <ErrorMessage name={name} />
          </StyledInputError>
        </>
      )}
    </Field>
  )
}

export default memo(TextField)
